
import { Link } from 'react-router-dom';
import useCampaign from '../../../hooks/useCampaign';

export default function TeaHero() {
  const { isActive, discountLabel } = useCampaign();

  return (
    <section className="relative min-h-[70vh] flex items-end overflow-hidden" aria-labelledby="tea-hero-title">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/399017c3fae040f75a3c3b5f71b2c9fb.jpg"
          alt="Craft Tea コラボレーション - 日本茶サブスクリプション"
          className="w-full h-full object-cover object-top"
          loading="eager"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pb-16 sm:pb-20 md:pb-24">
        <div className="flex flex-wrap items-center gap-3 mb-4 sm:mb-6">
          <span className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-white/10 backdrop-blur-sm text-white text-xs sm:text-sm font-light tracking-[0.1em] rounded-full border border-white/20">
            <i className="ri-leaf-line" aria-hidden="true"></i>
            MeVER × Craft Tea
          </span>
          <span className="px-3 py-1.5 bg-emerald-500/80 text-white text-xs font-medium rounded-full">
            COLLAB
          </span>
          {isActive && (
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs font-medium rounded-full shadow-lg animate-pulse">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              {discountLabel}
            </span>
          )}
        </div>

        <h1 id="tea-hero-title" className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.05em] leading-tight">
          よいお茶を、<br className="sm:hidden" />いつもそばに
        </h1>

        <p className="text-base sm:text-lg md:text-xl font-extralight text-white/80 max-w-2xl mb-8 sm:mb-10 leading-relaxed tracking-wide">
          Craft Tea厳選のシングルオリジン日本茶・和紅茶を、毎月あなたのデスクへ。<br className="hidden md:block" />
          クリエイティブワークに、一杯の静寂を。
        </p>

        <div className="flex flex-col sm:flex-row items-start gap-4">
          <a
            href="#plans"
            className={`w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 text-white text-sm sm:text-base font-light tracking-[0.1em] transition-colors whitespace-nowrap rounded-md cursor-pointer text-center ${
              isActive
                ? 'bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 font-medium shadow-lg'
                : 'bg-[#7B8C3E] hover:bg-[#6A7A35]'
            }`}
          >
            {isActive && <i className="ri-fire-fill mr-2" aria-hidden="true"></i>}
            {isActive ? 'キャンペーン価格でプランを見る' : 'プランを見る'}
          </a>
          <Link
            to="/"
            className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white text-sm sm:text-base font-light tracking-[0.1em] hover:bg-white/20 transition-colors whitespace-nowrap rounded-md border border-white/30 cursor-pointer text-center"
          >
            トップに戻る
          </Link>
        </div>
      </div>
    </section>
  );
}
